<template>
 <!-- 转账提示 -->
  <el-dialog width="400px" top="30vh" title="温馨提示" :visible.sync="innerVisible" append-to-body :before-close="close" :close-on-click-modal="false">
    <el-row class="dialog_wrap">
      <div class="title">请再次确认以下信息</div>
      <div class="content">
        <div>
          <span>收款账户 ：</span><span>{{ pay.accountName }}</span>
        </div>
        <div>
          <span>收款账号 ：</span><span>{{ pay.bankAccount }}</span>
        </div>
        <div>
         <span>报价金额(元) ：</span><span class="num">{{pay.amount}}</span>
        </div>
      </div>
      <div class="btnDia">
        <el-button @click="innerVisible = false">取消</el-button>
        <el-button class="btn-2" @click="operateSureEvt()">提交</el-button>
      </div>
    </el-row>
  </el-dialog>
</template>

<script>
export default {
  name: 'paySure',
  props: {
    pay: {
      accountName: '',
      bankAccount: '',
      amount: '',
    },
  },
  watch: {
    pay: {
      handler(newVal, oldVal) {
        if (newVal && newVal.accountName && newVal.bankAccount) {
          this.innerVisible = true
        }
      },
    },
  },
  data() {
    return {
      innerVisible: false,
    }
  },
  methods: {
    close() {
      this.innerVisible = false
    },
    operateSureEvt(){
      this.innerVisible = false
      this.$emit('operateSureEvt')
    }
  },
}
</script>

<style lang="scss" scoped>
.dialog_wrap {
  text-align: center;
  .title {
    font-size: 16px;
    color: #394259;
    padding-bottom: 20px;
  }
  .content {
    text-align: left;
    width: 90%;
    background: #f8f9fb;
    padding: 15px;
    div {
      font-size: 12px;
      color: #394259;
      margin-bottom: 10px;
      span{
        font-size: 12px;
        color: #898989;
      }
      span:first-child {
        width: 90px;
        display: inline-block;
      }
      span:last-child {
        padding-left: 10px;
      }
      .num{
        color: #5087fe; 
        font-size: 14px;
      }
    }
  }
}
</style>
